import React from "react";
import { useEffect, useState } from "react";
import { toast } from "sonner";
import api, { formatError } from "@/lib/api";
import { Plus, Pencil, Trash2 } from "lucide-react";

const empty = { name: "", slug: "", icon: "" };

export default function AdminCategories() {
  const [items, setItems] = useState([]);
  const [form, setForm] = useState(empty);
  const [editing, setEditing] = useState(null);

  const load = async () => {
    try {
      const r = await api.get("/categories");
      setItems(r.data);
    } catch {
      // abaikan error
    }
  };

  useEffect(() => {
    load();
  }, []);

  const save = async (e) => {
    e.preventDefault();
    try {
      if (editing) await api.put(`/categories/${editing}`, form);
      else await api.post("/categories", form);
      toast.success("Kategori disimpan");
      setForm(empty);
      setEditing(null);
      load();
    } catch (err) {
      toast.error(formatError(err));
    }
  };

  const remove = async (c) => {
    if (!window.confirm(`Hapus ${c.name}?`)) return;
    try {
      await api.delete(`/categories/${c.id}`);
      load();
    } catch (err) {
      toast.error(formatError(err));
    }
  };

  return (
    <div data-testid="admin-categories">
      <div className="label-mono text-zinc-500">// TAXONOMY</div>
      <h1 className="font-display text-3xl md:text-4xl font-black uppercase mt-1">Kategori</h1>

      <div className="mt-6 grid lg:grid-cols-3 gap-6">
        <form onSubmit={save} className="border border-black bg-white p-5 shadow-brutal h-fit">
          <div className="label-mono text-zinc-500">// {editing ? "EDIT" : "NEW"}</div>
          <h2 className="font-display text-xl font-black uppercase mt-1 mb-4">Form</h2>
          <label className="label-mono block mb-2">Nama</label>
          <input value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="input-brutal mb-3" required />
          <label className="label-mono block mb-2">Slug</label>
          <input value={form.slug} onChange={(e) => setForm({ ...form, slug: e.target.value })} className="input-brutal mb-3" required />
          <label className="label-mono block mb-2">Icon (lucide name)</label>
          <input value={form.icon} onChange={(e) => setForm({ ...form, icon: e.target.value })} className="input-brutal mb-4" />
          <button className="btn-primary w-full" type="submit">
            <Plus className="w-3 h-3 inline mr-1" />
            {editing ? "Update" : "Tambah"}
          </button>
          {editing && (
            <button
              onClick={() => { setEditing(null); setForm(empty); }}
              type="button"
              className="btn-secondary w-full mt-2"
            >
              Batal
            </button>
          )}
        </form>

        <div className="lg:col-span-2 border border-black bg-white">
          <table className="w-full text-sm">
            <thead className="bg-zinc-50 border-b border-black">
              <tr>
                <th className="p-3 text-left label-mono">NAMA</th>
                <th className="p-3 text-left label-mono">SLUG</th>
                <th className="p-3 text-right label-mono">AKSI</th>
              </tr>
            </thead>
            <tbody>
              {items.map((c) => (
                <tr key={c.id} className="border-b border-zinc-200" data-testid={`cat-row-${c.id}`}>
                  <td className="p-3 font-mono text-xs font-bold">{c.name}</td>
                  <td className="p-3 font-mono text-[10px] text-zinc-600">{c.slug}</td>
                  <td className="p-3 text-right">
                    <button
                      onClick={() => { setForm(c); setEditing(c.id); }}
                      className="p-2 border border-black hover:bg-black hover:text-white mr-2"
                    >
                      <Pencil className="w-3 h-3" />
                    </button>
                    <button
                      onClick={() => remove(c)}
                      className="p-2 border border-black hover:bg-[#FF3333] hover:text-white"
                    >
                      <Trash2 className="w-3 h-3" />
                    </button>
                  </td>
                </tr>
              ))}
              {items.length === 0 && (
                <tr>
                  <td colSpan={3} className="p-6 text-center font-mono text-xs text-zinc-500">
                    // belum ada kategori
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
